import {Button, Col, Row, Toast} from "react-bootstrap";
import React, {useState} from "react";
import {Banner} from "Stores/bannerStore";
import Markdown from "Components/Common/Markdown";
import {
    CalendarAltIcon,
    ExclamationCircleIcon,
    HeartFilledIcon,
    HeartIcon,
    InfoCircleIcon,
    RocketIcon,
    TimesCircleIcon
} from "Components/Icons/Icons";

interface BannerItemProps {
    item: Banner
    isAuthenticated?: boolean
    onClose?: () => void
    onLike?: () => void
    onRemindMeLater?: () => void
}

export default function BannerItem({item, onClose, onLike, onRemindMeLater, isAuthenticated}: BannerItemProps) {
    const [likeChecked, setLikeChecked] = useState(false);
    const getCTALabel = (cta: string) => {
        if (cta === "learn_more") {
            return "Learn more";
        } else if (cta === "letsgo") {
            return "Let's go";
        } else if (cta === "register") {
            return "Register";
        } else {
            return "CTA";
        }
    };

    const getButtonVariant = (notificationType: string) => {
        if (notificationType === "announcement") {
            return "announcement";
        } else if (notificationType === "event") {
            return "event";
        } else if (notificationType === "warning") {
            return "warning";
        } else if (notificationType === "error") {
            return "danger";
        } else if (notificationType === "new_feature") {
            return "new_feature";
        } else {
            return "primary";
        }
    };

    const getButtonIcon = (notificationType: string) => {
        if (notificationType === "announcement") {
            return <InfoCircleIcon />;
        } else if (notificationType === "event") {
            return <CalendarAltIcon />;
        } else if (notificationType === "warning") {
            return <ExclamationCircleIcon />;
        } else if (notificationType === "error") {
            return <TimesCircleIcon />;
        } else if (notificationType === "new_feature") {
            return <RocketIcon />;
        } else {
            return "primary";
        }
    };

    const handleClose = () => {
        if (onClose) {
            onClose();
        }
    };

    const handleLike = () => {
        if (onLike && !likeChecked) {
            onLike();
            setLikeChecked(true);
        }
    };

    const handleRemindMeLater = () => {
        if (onRemindMeLater) {
            onRemindMeLater();
        }
    };

    return (
        <Toast className="d-inline-block text-start" bsPrefix="enflux-toast toast" onClose={() => handleClose()}>
            <Toast.Header>
                {item.notification_type && <span className={`me-2 badge ${getButtonVariant(item.notification_type)}`}>{getButtonIcon(item.notification_type)}</span>}
                <strong className="me-auto p-1">{item.banner_text || "Title"}</strong>
            </Toast.Header>
            <Toast.Body>
                <p>{item.description && (<Markdown>{item.description}</Markdown>) || "Description"}</p>
                <Row>
                    {item.like_button && isAuthenticated && <Col xs="2"><Button variant="icon" onClick={handleLike}>{likeChecked ? <HeartFilledIcon /> : <HeartIcon />}</Button></Col>}
                    <Col>
                        {item.remind_me_later && <Button variant="light" className="w-100" onClick={handleRemindMeLater}>Remind me later</Button>}
                    </Col>
                    <Col>
                        {item.cta && <Button variant={getButtonVariant(item.notification_type)} className="w-100" as="a" target="_blank" href={item.cta_url}>{getCTALabel(item.cta_text)}</Button>}
                    </Col>
                </Row>
            </Toast.Body>
        </Toast>
    );
}